'use client';

import { c as _c } from "react/compiler-runtime";
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { ReactNode } from 'react';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import { PageNavigationIndicator } from '@/app/components/PageNavigationIndicator';
import { env } from '@/env';
import { getQueryClient } from '@/lib/getQueryClient';
import '../lib/initDatadogRum';
export interface ProvidersProps {
  children: ReactNode;
}
export function Providers(t0) {
  const $ = _c(6);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getQueryClient();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const queryClient = t1;
  let t2;
  if ($[1] !== children) {
    t2 = <NuqsAdapter><PageNavigationIndicator>{children}</PageNavigationIndicator></NuqsAdapter>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = env.NEXT_PUBLIC_ENABLE_DEV_TOOLS ? <ReactQueryDevtools initialIsOpen={false} /> : null;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <QueryClientProvider client={queryClient}>{t2}{t3}</QueryClientProvider>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}